"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.containerTemplate = void 0;
var tslib_1 = require("tslib");
var container_dot_1 = (0, tslib_1.__importDefault)(require("./container.dot"));
var containerTemplate = container_dot_1.default.default ? container_dot_1.default.default : container_dot_1.default;
exports.containerTemplate = containerTemplate;
//# sourceMappingURL=index.js.map